import "bootstrap/dist/js/bootstrap";
import "select2";
import "select2/dist/css/select2.css";
import "jquery-datetimepicker";
import initSharedOptionsSelects from "../sharedOptionsSelect";

// fix for select2 + turbolinks
// see https://stackoverflow.com/a/41915129/1343921
$(document).on("turbolinks:before-cache", function () {
  $("select.select2-hidden-accessible").select2("destroy");
});

// Hooks for Select2 and date/time pickers
$(document).on("turbolinks:load", function () {
  $("select")
    .not(".default-select")
    .not(".select2-hidden-accessible")
    .not(".shared-options-select")
    .select2();
  initSharedOptionsSelects(document);

  $(".date-time-picker-input").datetimepicker();
  $(".date-picker-input").datetimepicker({
    format: "d/m/Y",
    timepicker: false,
  });
});

function requireAll(r) {
  r.keys().forEach(r);
}

// Legacy imports for the JS code we had prior to Webpackerization
require("./cable");
require("./serviceworker-companion");
require("./browser_notifications.js");
requireAll(require.context("./admin", true, /.*/));
requireAll(require.context("./channels", true, /.*/));
requireAll(require.context("./chat", true, /.*/));
